<template>
  <v-app>
    <v-app-bar
      color="primary"
      elevation="0"
      height="110px"
      class="d-none d-md-block header"
    >
      <header-base class="p-0" />
    </v-app-bar>
    <v-main>
      <SnackBar/>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import HeaderBase from "@/components/HeaderBase.vue";
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: "AppVue",
  components: { HeaderBase, SnackBar },
};
</script>

<style>
.header {
  flex: 0;
}
</style>
